// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__TfiVq","tab":"Tabs_tab__GYIS5","selected":"Tabs_selected__imWGy","container":"Tabs_container__23tJq","content":"Tabs_content__e3-BO"};